if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
      };
      this.mql = window.matchMedia('(min-width: 750px)');
      this.mediaChangeToken = 0;
      if (!this.elements.viewer) return;
      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      if (this.elements.thumbnails) {
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          const button = mediaToSwitch.querySelector('button');
          if (button) button.addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
      }
      if (this.dataset.desktopLayout && this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
    }
    onSlideChanged(event) {
      if (!this.elements.thumbnails) return;
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${event.detail.currentElement.dataset.mediaId}"]`);
      this.setActiveThumbnail(thumbnail);
    }
    setActiveMedia(mediaId, prepend) {
      if (!this.elements.viewer) return;
      const mediaItems = Array.from(this.elements.viewer.querySelectorAll('[data-media-id]'));
      const activeMedia = mediaItems.find((item) => item.dataset.mediaId === String(mediaId));
      if (!activeMedia) return;
      mediaItems.forEach((item) => item.classList.toggle('is-active', item === activeMedia));
      const mediaList = activeMedia.parentElement;
      if (prepend && mediaList) {
        // Dawn's slider relies on the featured variant's media being first. Keeping DOM order unchanged breaks mobile colour switching.
        if (mediaList.firstElementChild !== activeMedia) mediaList.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumb = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
          if (activeThumb && activeThumb.parentElement.firstElementChild !== activeThumb) activeThumb.parentElement.prepend(activeThumb);
        }
        // Immediately display the selected colour's first slide; do not scroll the entire document.
        const slider = this.elements.viewer.slider || mediaList;
        slider.scrollLeft = 0;
        if (typeof this.elements.viewer.resetPages === 'function') this.elements.viewer.resetPages();
        window.requestAnimationFrame(() => {
          if (!slider.isConnected) return;
          slider.scrollLeft = 0;
          if (typeof this.elements.viewer.update === 'function') this.elements.viewer.update();
        });
      } else if (mediaList && (!this.mql.matches || this.elements.thumbnails)) {
        window.requestAnimationFrame(() => {
          if (mediaList.isConnected) mediaList.scrollTo({ left: activeMedia.offsetLeft, behavior: 'auto' });
        });
      }
      this.preventStickyHeader();
      this.playActiveMedia(activeMedia);
      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
      if (activeThumbnail) {
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }
    }
    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;
      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      const button = thumbnail.querySelector('button');
      if (button) button.setAttribute('aria-current', true);
      if (typeof this.elements.thumbnails.isSlideVisible === 'function' && this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;
      if (this.elements.thumbnails.slider) this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft, behavior: 'auto' });
    }
    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image || !this.elements.liveRegion || !window.accessibilityStrings) return;
      const announce = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', 'false');
        this.elements.liveRegion.textContent = window.accessibilityStrings.imageAvailable.replace('[index]', position);
        window.setTimeout(() => this.elements.liveRegion.setAttribute('aria-hidden', 'true'), 2000);
      };
      if (image.complete && image.naturalWidth) announce();
      else image.addEventListener('load', announce, { once: true });
    }
    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }
    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (this.stickyHeader) this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }
    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
    }
  });
}
